import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withHandlers, compose, lifecycle, branch, renderComponent } from 'recompose'
import { push } from 'react-router-redux'

import { api } from 'modules/user/api'
import { uploadFile } from 'modules/file/api'

import * as actions from 'modules/profile/actions'
import * as UserSelectors from 'modules/user/selectors'
import * as UserActions from 'modules/user/actions'
import { getRoot } from 'modules/user/selectors'
import { page, track } from 'utils/trackingUtils'

import { ProfilePhotoStep, AEProfilePhotoStep } from './component'

const mapStateToProps = state => ({
  user: getRoot(state),
  profile: state.profile,
  name: UserSelectors.getName(state),
  stagedProfilePicture: UserSelectors.getProfilePicture(state),
  isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
  isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
  avatarUrl: UserSelectors.getAvatarUrl(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    uploadCoverPhoto: actions.uploadCoverPhoto,
    createProfile: actions.createProfile,
    setName: UserActions.setName,
    updateUser: UserActions.updateUser,
    stageProfilePicture: UserActions.stageProfilePicture,
    setAvatarUrl: UserActions.setAvatarUrl,
    push
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Profile Name and Photo Setup', {
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow 
          ? 'rep-onboarding' 
          : 'sales-onboarding',
      })
    }
  }),
  withHandlers({
    onDrop: props => files => {
      const file = files[0]
      if (props.isCalendarSeat) {
        uploadFile(files[0])
        .then(response => {
          const newFileUrl = response.downloadUrl
          props.actions.setAvatarUrl(newFileUrl)
        })
      } else {
        props.isRepInvitedFlow
          ? props.actions.stageProfilePicture(file)
          : props.actions.uploadCoverPhoto(file)
      }
    },
    onContinueClick: props => () => {
      track('Onboarding Profile Name and Photo Setup Completed', {
        context: props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : props.isRepInvitedFlow 
          ? 'rep-onboarding' 
          : 'sales-onboarding',
        skipped: false
      })

      if (props.isCalendarSeat) {
        api.setName(props.user.userId, {name: props.user.name, avatarUrl: props.avatarUrl})
          .then(() => props.actions.createProfile())
      } else {
        !props.isRepInvitedFlow && api.setName(props.user.userId, {name: props.user.name})
          .then(() => props.actions.createProfile())
      }
      
      if (props.isCalendarSeat) {
        props.actions.push('/setup/calendaring/connect')
      } else if (props.isSSOProvisionedFlow) {
        props.actions.push('/setup/meetings')
      } else if (props.isRepInvitedFlow) {
        props.actions.push('/setup/password')
      } else {
        props.actions.push('/setup/profile/color')
      }
    },
    onNameChange: props => event => {
      props.actions.setName(event.target.value)
    },
  }),
  branch(props => props.isCalendarSeat, renderComponent(AEProfilePhotoStep)),
)(ProfilePhotoStep)



// WEBPACK FOOTER //
// ./src/layouts/ProfilePhotoStep/index.js